export const formatData = (
  key,
  file: any,
  additionalFields: { key: string; value: string }[] = []
) => {
  const formData = new FormData();
  formData.append(key, file, file.name);

  additionalFields.forEach(({ key, value }) => formData.append(key, value));

  return formData;
};
